import React, { useEffect, useState } from 'react'
import { Table, Row, Col, Form, Button, Modal } from 'react-bootstrap'
import { parseDateBR } from 'helpers/date.js'
import CurrencyFormat from 'react-currency-format'
import Pagination from 'react-js-pagination'
import { Add, FileCopyRounded, ListAltOutlined } from '@material-ui/icons'
import exportTable from 'helpers/export'
import { Trans } from 'react-i18next'
import Loading from 'components/Loading'
import masterAgentService from 'services/master-agent-request'
import DatePicker from './DatePicker'

const TableMasterAgent = ({
  collection,
  columns,
  filtersList,
  btnAddProps,
  additionalButtons,
  fileExportName,
  exportFile,
  showActionsButton,
  isLoading,
  setFiltersList
}) => {
  const [_data, setData] = useState([]);
  const [_columns, setColumns] = useState([]);
  const [providers, setProviders] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  const [totalValue, setTotalValue] = useState(0)
  const [products, setProducts] = useState([])
  const [productsIsLoading, setProductsIsLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 5,
    total: 0
  })
  const [filters, setFilters] = useState({
    'Fornecedor': null
  });

  useEffect(() => {
    for (let item of collection) {
      let aux = providers
      aux[item.Fornecedor] = item.Fornecedor
      setProviders(aux)
    }
    setPagination({ ...pagination, total: collection.length })
    setData(collection)
    setColumns(columns)
  }, [collection, columns])

  const getProducts = async (id) => {
    const clicked = _data.filter(d => d.FormID == id)[0]
    setModalHeader(`Pedido: Nº - ${clicked.Number}`)
    setProductsIsLoading(true)
    setShowModal(true)
    const response = await masterAgentService.getProducts(id)
    const { data: result } = response
    let sum = totalValue
    for (let item of result) {
      setTotalValue(sum += item.total)
    }
    await Promise.resolve().then(() => setProducts(result))
    setProductsIsLoading(false)
  }

  const onHideModal = () => {
    if (isLoading) return;
    
    setShowModal(false)
    setTotalValue(0)
  }
  
  const formatValue = (value, col) => {
    if (col == "FormID" && showActionsButton) {
      return (
        <Button
          size="sm"
          variant="info"
          onClick={() => getProducts(value)}
          value={value}
        >
          <ListAltOutlined />
        </Button>
      )
    } else {
      if (!value)
        return '--';
      else if (!isNaN(value) && value && value.toString().indexOf('.') != -1 && col != "Porcentagem Comissão")
        return <CurrencyFormat value={parseFloat(value)} thousandSeparator="." decimalSeparator="," prefix="R$ " fixedDecimalScale={true} decimalScale={2} displayType={'text'} />
      else if (value % 1 !== 0 && !isNaN(Date.parse(value)) && value.length > 8)
        return parseDateBR(value)
      else if (typeof value == "string")
        return col == "Porcentagem Comissão" ? parseFloat(value).toFixed(2)+"%" : value;
    }
  }

  const doFilter = (item) => {
    let retorno = true

    if (filters.Fornecedor) {
      retorno = retorno && item['Fornecedor'] == filters.Fornecedor
    }

    Object.keys(filtersList).map(async (_filter) => {
      if (filters[_filter]) {
        if (filtersList[_filter].comparator === "like") {
          if (filtersList[_filter].hasOwnProperty('ref')) {
            if (item[filtersList[_filter].ref] != "--" && filters[_filter] != "--") {
              retorno = retorno && (item[filtersList[_filter].ref].toLowerCase().indexOf(filters[_filter].toLowerCase()) != -1)
            } else {
              retorno = retorno && item[filtersList[_filter].ref] == ""
            }
          } else {
            if (filtersList[_filter].hasOwnProperty('columns')) {
              for (let col of filtersList[_filter].columns) {
                return retorno = retorno && (item[col].toLowerCase().indexOf(filters[_filter].toLowerCase()) != -1)
              }
            } else 
              retorno = retorno && (item[_filter].toLowerCase().indexOf(filters[_filter].toLowerCase()) != -1)            
          }
        } else if (filtersList[_filter].comparator === "equal") {
          retorno = retorno && item[_filter] == filters[_filter]
        } else if (filtersList[_filter].comparator === "between") {
          const {from, to} = filtersList[_filter].data     
          if (from.value && to.value) {
            retorno = retorno && (
              new Date(item[filtersList[_filter].ref]).getTime() >= new Date(from.value).getTime() && 
              new Date(item[filtersList[_filter].ref]).getTime() <= new Date(to.value).getTime()
            )
          }          
        }
      }
    })

    return retorno
  }

  const paginate = (array, page_size, page_number) => {
    page_number -= 1
    return array.slice(page_number * page_size, page_number * page_size + page_size)
  }

  const buildTable = items => {
    return (
      <Table
        responsive
        striped
      >
        <thead>
          <tr>
            {columns.map(col => {
              if (col.visible) {
                return (
                  <th key={col.dataField} className="text-center">
                    {col.text}
                  </th>
                )
              }
            })}
            {showActionsButton ? (
              <th>
                Info
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {items.map((item, d_i) => {
            return (
              <tr key={d_i}>
                {columns.map((col, c_i) => {
                  return (
                    <td key={c_i} style={{ textAlign: 'center' }}>
                      {formatValue(item[col.text], col.text)}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  const buildTableProducts = () => {
    const formatValue = value => value
      .toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'})

    return (<>
      {products.map((prod, key) => {
        return (
          <tr key={key}>
            <td>{prod.name}</td>
            <td className="text-center">{prod.amount}</td>
            <td className="text-center">{prod.type}</td>
            <td className="text-center">{formatValue(prod.negotiated_value)}</td>
            <td className="text-center">{formatValue(prod.total)}</td>
          </tr>
        )
      })}
      <tr style={{background: '#eee'}}>
        <td colSpan="3" style={{visibility: 'hidden'}}></td>
        <td className="text-center"><strong>Total</strong></td>
        <td className="text-center"><strong>{formatValue(totalValue)}</strong></td>
      </tr>
    </>)
  }

  const customTotal = () => {
    let from = ((pagination.per_page * pagination.current_page) - pagination.per_page) + 1
    let to = _data.filter(doFilter).length < (pagination.per_page * pagination.current_page) ? _data.filter(doFilter).length : pagination.per_page * pagination.current_page
    return (
      <Trans i18nKey="label:interpolateShowingRecords">
        Showing {{ from: from }} to{' '}
        {{ to: to }} from {{ total: _data.filter(doFilter).length }}{' '}
        records
      </Trans>
    )
  }

  return (<>
    <Row>
      {isLoading ? (
        <Col md="12" className="d-flex justify-content-center">
          <Loading page />
        </Col>
      ) : (<>        
        <Col md="12" className="mb-3">
          <Button className="btn-add  mr-3" href={btnAddProps.url}><Add /> {btnAddProps.label}</Button>
          {additionalButtons ? additionalButtons() : (<></>)}
          {exportFile && _data.length > 0 ? (
            <Button
              variant="info"
              onClick={() => {
                fileExportName += `-${new Date().toISOString()}`
                exportTable(buildTable(_data.filter(doFilter)), fileExportName);
              }}
            >
              Exportar <FileCopyRounded />
            </Button>
          ) : null}
        </Col>
        {_data.length > 0 ? (<>
          <Col className="mb-3">
            <Form.Row>
              <Col md="1">
                <Form.Group>
                  <Form.Label>Por Pagina</Form.Label>
                  <Form.Control
                    as="select"
                    value={pagination.per_page}
                    onChange={({ target }) => {
                      setPagination({ ...pagination, per_page: parseInt(target.value), current_page: 1 })
                    }}
                  >
                    <option>5</option>
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>
                    <option>50</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              {Object.keys(providers).length ? (
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Fornecedor</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={({ target }) => {
                        setFilters({ ...filters, Fornecedor: target.value })
                        setPagination({ ...pagination, current_page: 1 })
                      }}
                    >
                      <option value="">Selecione</option>
                      {Object.keys(providers).map((provider, key) => <option key={key}>{provider}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
              ) : null}
              {filtersList ?
                Object.keys(filtersList).map(_filter => {
                  if (filtersList[_filter].type == 'date') {
                    return (
                      Object.keys(filtersList[_filter].data).map((index, k) => (
                        <Col md={filtersList[_filter].width} key={index}>
                          <Form.Group>
                            <Form.Label>
                              {filtersList[_filter].data[index].label}
                            </Form.Label>
                            <DatePicker
                              pagination={pagination}
                              setPagination={setPagination}
                              setFilters={setFilters}
                              filters={filters}
                              filtersList={filtersList}
                              filter={_filter}
                              index={index}
                              setFiltersList={setFiltersList}
                            />
                          </Form.Group>
                        </Col>
                      ))
                    )
                  } else {
                    return (
                      <Col md={filtersList[_filter].width} key={_filter}>
                        <Form.Group>
                          <Form.Label>{_filter}</Form.Label>
                          <Form.Control
                            as={filtersList[_filter].type}
                            onChange={({ target }) => {
                              setFilters({ ...filters, [_filter]: target.value })
                              setPagination({ ...pagination, current_page: 1 })
                            }}
                          >
                            {filtersList[_filter].type === "select" ? (<>
                              <option value="">Selecione</option>
                              {Object.keys(filtersList[_filter].options).sort().map((option, key) => <option key={key} >{option}</option>)}
                            </>) : null}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    )
                  }
                })
                : null}
            </Form.Row>
          </Col>
          <Col md="12">
            {columns.length ? (
              buildTable(paginate(_data.filter(doFilter), pagination.per_page, pagination.current_page))
            ) : null}
          </Col>
        </>) : (
          <Col md="12" className="d-flex justify-content-center">
            <span className="h4">Sem dados pra essa revenda</span>
          </Col>
        )}
      </>)}

    </Row>
    {pagination.total ? (
      <Row>
        <Col xs="12" md="6" className="d-flex justify-content-start">
          {customTotal()}
        </Col>
        <Col md="6" className="d-flex justify-content-end">
          <Pagination
            activePage={pagination.current_page}
            itemsCountPerPage={pagination.per_page}
            totalItemsCount={_data.filter(doFilter).length}
            pageRangeDisplayed={3}
            onChange={(page) => setPagination({ ...pagination, ...{ current_page: page } })}
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="‹"
            nextPageText="›"
          />
        </Col>
      </Row>
    ) : null}

    <Modal 
      centered 
      size="lg" 
      show={showModal} 
      onHide={() => onHideModal()}
    >
      <Modal.Header closeButton>
        <Modal.Title>{modalHeader}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {productsIsLoading ? (<Loading page />) : (
          <Table bordered>
            <thead>
              <tr className='text-center'>
                <th>Produto</th>
                <th>Quantidade</th>
                <th>Tipo</th>
                <th>Valor p/ Unidade</th>
                <th>Total p/ Produto</th>
              </tr>
            </thead>
            <tbody>{buildTableProducts()}</tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHideModal()}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  </>)
}

TableMasterAgent.defaultProps = {
  exportFile: true,
  showActionsButton: false,
  additionalButtons: null
}

export default TableMasterAgent